// Mock data for Ljungdalens Turridning website
// All images are from the original ljungdalensturridning.se (owned by Lena Selnert)

const B = "https://impro.usercontent.one/appid/oneComWsb/domain/ljungdalensturridning.se/media/ljungdalensturridning.se/onewebmedia";

// Direct URLs as served by the original website's CDN (preserving exact query strings)
const PHOTOS = {
  lenas1051_lg: `${B}/lenas%20bilder%201051.jpeg?etag=%22e2cea-600c8063%22&sourceContentType=image%2Fjpeg&ignoreAspectRatio&resize=2500,1407&quality=85`,
  lenas1042: `${B}/lenas%20bilder%201042.jpg?etag=%2236bc0-600c8066%22&sourceContentType=image%2Fjpeg&quality=85`,
  lenas926_lg: `${B}/lenas%20bilder%20926.jpg?etag=%2217afd1-600c806c%22&sourceContentType=image%2Fjpeg&ignoreAspectRatio&resize=2500,1500&quality=85`,
  lenas1011_lg: `${B}/lenas%20bilder%201011.jpeg?etag=%221b75be-600c806b%22&sourceContentType=image%2Fjpeg&ignoreAspectRatio&resize=2500,1875&quality=85`,
  lenas989_lg: `${B}/lenas%20bilder%20989.jpg?etag=%22174cd4-600c8cf8%22&sourceContentType=image%2Fjpeg&ignoreAspectRatio&resize=2500,1500&quality=85`,
  lenas1007_lg: `${B}/lenas%20bilder%201007.jpeg?etag=%2219f65f-600c8065%22&sourceContentType=image%2Fjpeg&ignoreAspectRatio&resize=2500,1875&quality=85`,
  lenas978: `${B}/lenas%20bilder%20978%20(2).jpg?etag=%228ea78-600c8063%22&sourceContentType=image%2Fjpeg&quality=85`,
  lenas977: `${B}/lenas%20bilder%20977%20(2).jpg?etag=%2239da3-600c8060%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb1: `${B}/272770587_246850330931308_968344739783830294_n.jpg?etag=%22200a6-61f5668d%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb2: `${B}/272703419_314949690564994_5999853163706069802_n.jpg?etag=%2228992-61f5668c%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb3: `${B}/272695577_972147847041697_7497758448436021024_n.jpg?etag=%222c009-61f56688%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb4: `${B}/272105330_305366414891730_5613825594627810918_n.jpg?etag=%2222d2b-61f5668b%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb5: `${B}/272791579_932081000837404_14680565481163834_n.jpg?etag=%22204a3-61f56687%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb6: `${B}/272130207_5048181755220344_6226966929811102821_n.jpg?etag=%2222373-61f56689%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb7: `${B}/272102889_1330385127434824_2635477368833654357_n.jpg?etag=%2220bb9-61f5668a%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb8: `${B}/272910229_982822272636910_4711009588675604001_n.jpg?etag=%2220293-61f56686%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb9: `${B}/272725302_3025185054402492_7468455829699351605_n.jpg?etag=%2228a17-61f56686%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb10: `${B}/272105326_887374731952490_5368270451500524971_n.jpg?etag=%2210665-61f56684%22&sourceContentType=image%2Fjpeg&quality=85`,
  hjalp: `${B}/hj%C3%A4lp%20mig%204.jpg?etag=%2229f12-61f5625b%22&sourceContentType=image%2Fjpeg&quality=85`,
  fb11: `${B}/336834801_1594241621085929_3888194398713098954_n.jpg?etag=%224f017-642046b1%22&sourceContentType=image%2Fjpeg&quality=85`,
};

export const siteInfo = {
  name: "Ljungdalens Turridning",
  tagline: "Fantastiska ridturer i ljungdalsfjällen",
  phone: "0702209827",
  email: "lenaselnert123@gmail.com",
  address: "845 99 Ljungdalen, Sweden",
  facebook: "https://facebook.com/Ljungdalen-Turridning-105767654851268",
  maps: "https://www.google.com/maps?q=62.859135,12.785185",
  seasonStart: "15 juni 2026",
};

export const navLinks = [
  { label: "Om oss", href: "#om-oss" },
  { label: "Ridturer", href: "#ridturer" },
  { label: "Hästarna", href: "#hastarna" },
  { label: "Galleri", href: "#galleri" },
  { label: "Hitta oss", href: "#hitta-oss" },
  { label: "Kontakt", href: "#kontakt" },
];

export const aboutText = [
  "Ljungdalens turridning AB är ett företag som erbjuder turridning i ljungdalsfjällen med omnejd. Jag Lena Selnert är den som driver företaget och har mångårig erfarenhet av hästar och ridning.",
  "Vi erbjuder hel- och halvdagsturer på fjället. För närvarande har vi möjlighet att erbjuda fyra platser åt gången.",
];

export const tours = [
  {
    id: "kort",
    name: "Kort tur",
    duration: "Cirka 2 timmar",
    price: "900 kr",
    priceNote: "inkl. moms",
    description:
      "En skön introduktion till turridning i fjällandskapet. Perfekt för dig som vill känna pulsen av naturen under en kortare stund.",
    image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/aip41kqm_lenas%20bilder%20985.jpg",
    popular: false,
  },
  {
    id: "halvdag",
    name: "Halvdagstur",
    duration: "Cirka 4 timmar",
    price: "1 600 kr",
    priceNote: "inkl. moms",
    description:
      "En halv dag bland vidder, myrar och fjälltoppar. Upplev ljungdalsfjällens lugn och storslagenhet i din egen takt.",
    image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/b59iv4r6_lenas%20bilder%201042.jpg",
    popular: true,
  },
  {
    id: "heldag",
    name: "Heldagstur",
    duration: "Cirka 8 timmar",
    price: "2 800 kr",
    priceNote: "inkl. moms",
    description:
      "En hel dag på fjället — djupa dalar, glittrande vatten och oändliga vyer. Vår mest efterfrågade upplevelse för den vana ryttaren.",
    image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/5nq52od1_lenas%20bilder%201050.jpeg",
    popular: false,
  },
];

export const horses = [
  { name: "Livia", type: "Varmblodssto", born: "2005", image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/qcf02bl1_lenas%20bilder%201009.jpeg" },
  { name: "Pärla", type: "Kallblodssto", born: "2008", image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/3enk50ba_lenas%20bilder%201046.jpg", focus: { scale: 2.3, position: "30% 35%" } },
  { name: "Görrjill", type: "Kallblodssto", born: "2014", image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/fu4pr7w7_lenas%20bilder%20940.jpg" },
  { name: "Svarten", type: "Kallblodsvallack", born: "2009", image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/x9vr1mbp_lenas%20bilder%20941.jpg" },
  { name: "Eddie", type: "Quartervallack", born: "2011", image: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/uqfvhmno_Eddie.png" },
];

export const gallery = [
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/kxst5sgq_lenas%20bilder%201011.jpeg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/0dp2lo1y_lenas%20bilder%201006.jpg", rotate: -90 },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/xpexdpvv_lenas%20bilder%20985.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/th0fvtzr_lenas%20bilder%201008.jpeg" },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/25az72v3_lenas%20bilder%201013.mp4",
    poster: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/oi9euftu_lenas%20bilder%201010.jpeg",
  },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/uh5u5r3w_lenas%20bilder%201040.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/i2up3rbv_lenas%20bilder%201042.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/hko0eoge_e6bc3e24-a041-4ed9-ad91-04a26a64b5a4.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/ebynyggl_44a1165c-f67d-4220-bff2-a639dc8a101e.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/5nofbs2s_d98b9a04-f982-4dad-82f1-e29dea6454da.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/1xapglon_e67eb586-0152-4059-b7e0-f474b49cb0c4.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/bzuqhn6e_a97a7509-73ad-4e95-a3f8-4f60287c6822.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/0u9g93wg_c7fba17c-8637-4f65-8ddd-e438e8ced66f.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/ddbtu294_6bb6815c-af30-4c39-8d1a-9291acf3c007.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/rir84v0x_20906369-22f0-4a88-8633-12d836e42665.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/yyyc7h4s_lenas%20bilder%201051.jpeg" },
];

export const heroImage = "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/oi9euftu_lenas%20bilder%201010.jpeg";
export const aboutImage = "https://customer-assets.emergentagent.com/job_stable-modern/artifacts/yyyc7h4s_lenas%20bilder%201051.jpeg";

export const partners = [
  { name: "Fjällhornet", url: "https://www.fjallhornet.se/sv" },
  {
    name: "Ljungdalens Vandrarhem",
    url: "https://www.svenskaturistforeningen.se/boende/stf-ljungdalen-vandrarhem/",
  },
  { name: "Pensionat Helags", url: "https://pensionathelags.se/" },
  {
    name: "Ljungdalens Stugby",
    url: "https://ljungdalsfjallen.se/boende-stugor/ljungdalens-stugby-2/",
  },
];

export const bookingInfo = {
  equipment:
    "Oömma kläder, regnkläder, lämplig fotbeklädnad, eventuella egna skydd. Hjälm finns att låna.",
  ridvana:
    "Kunna behärska hästen i gångarterna: skritt, trav och galopp. Åldersgräns 12 år.",
  payment:
    "Vid bokning betalas halva summan, resterande betalas på plats via Swish eller banköverföring. Märk betalningen med namn och bokningsdatum.",
  cancellation:
    "Avbokning sker senast 10 dagar innan bokat datum mot en avgift på 200 kr utav det utlagda bokningsbeloppet. Resterande av bokningsbeloppet återbetalas.",
  tax: "Tänk på att turriding är avdragsgillt som motions- och friskvårdsaktivitet!",
};
